import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';
import { NewDeliveryTypeStore, CreateDeliveryTypeDto } from 'stores/configuration/events-n-requests/delivery-types-store';
import { nameof } from 'utils/object';

interface NewDeliveryTypeViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newDeliveryType?: NewDeliveryTypeStore;
}

// tslint:disable-next-line:no-empty-interface
interface NewDeliveryTypeViewState {
  userClickedSaved: boolean;
}

@connect(['newDeliveryType', NewDeliveryTypeStore])
class NewDeliveryTypeView extends React.Component<NewDeliveryTypeViewProps, NewDeliveryTypeViewState> {
  private get newDeliveryTypeStore() {
    return this.props.newDeliveryType;
  }

  constructor(props: NewDeliveryTypeViewProps) {
    super(props);
    this.newDeliveryTypeStore.createNew({
      name: ''
    });
    this.state = {
      userClickedSaved: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: NewDeliveryTypeViewProps) {
    if (this.newDeliveryTypeStore.state.result && this.newDeliveryTypeStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onCreateNewItem() {
    this.setState({ userClickedSaved: true });
    this.newDeliveryTypeStore.submit();
  }

  @autobind
  private onCancelNewItem() {
    this.newDeliveryTypeStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.newDeliveryTypeStore.change({ ...this.newDeliveryTypeStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.newDeliveryTypeStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('New Delivery Type')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.newDeliveryTypeStore.state.result && !this.newDeliveryTypeStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.newDeliveryTypeStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.newDeliveryTypeStore.state.item && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    required
                    fluid
                    error={!this.newDeliveryTypeStore.state.item.name && this.state.userClickedSaved}
                    label={t('Delivery Type')}
                    placeholder={t('Name')}
                    value={this.newDeliveryTypeStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateDeliveryTypeDto>('name'), value)}
                  />
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onCreateNewItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewDeliveryTypeView);
